import { render, staticRenderFns } from "./space-payment-table.vue?vue&type=template&id=3c9f1fdc"
import script from "./space-payment-table.vue?vue&type=script&lang=js"
export * from "./space-payment-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports